import { useRouter } from 'common/hooks/useRouter'
import OtpModule from 'common/modules/OtpPage'
import { useForgetValidation } from 'services/forgetPassword'

/////////////////////need ///////////////////
// mobile ,nationalCode from state in react-router
////////////////////////////////////////////

function ForgetValidation() {
  const { navigate, history: { state: { mobile, nationalCode } } } = useRouter()

  const { mutate } = useForgetValidation({
    onSuccess: (data) => {
      const { succeeded } = data
      if (succeeded) {
        navigate.push("/forget-password/change-password", {
          state: { mobile, nationalCode }
        })
      }
    }
  })

  const handleSubmitOtp = (data: ISubmitOtpModuleType) => {
    const res: reqForgetPasswordValidationType = {
      mobile,
      nationalCode,
      otp: data.otp,
      captchaValue: data.captchaValue,
      captchaKey: data.captchaKey
    }

    mutate(res)
  }

  return (
    <div>
      <OtpModule {...{ handleSubmitOtp }} />
    </div>
  )
}

export default ForgetValidation